<div style="position: relative;">
  <input type="text" class="focus-input" />
  <app-vplaybook-audio-player [setIsPlaying]="false" [setAudioSrc]="getAudioAsset(false)"
    [audioAssetId]="contentBlock.id">
  </app-vplaybook-audio-player>
  <span class="audio-caption" [hidden]="contentBlock.audioBlock?.caption == ''"
  [innerHtml]="contentBlock.audioBlock?.caption | safe:'html'"></span>
</div>

<ng-template #EditAudioModal>
  <div class="modal-content">
    <div class="modal-header">
      Edit Audio
      <i class="material-icons" data-bs-dismiss="modal" (click)='closeEditAudioModal()'>close</i>
    </div>
    <div class="modal-body me-3">
      <div class="form-group row mb-2">
        <label class="col-sm-3 control-label required-field">Audio</label>
        <div class="col-sm-6">
          @if (audBlock.asset != null && audBlock.asset.name != '') {
            <span class="audio-title file-title">
              <!-- href test -->
              <a (click)="getAssetAzureUrl(getAudioAsset(true))" class="pointer" target="_blank" title="{{audBlock.asset.name}}">
                {{audBlock.asset.name}}
              </a>
            </span>
          }
          @if (showProgress) {
            <section class="modal-pop" style="position:relative !important;">
              <div class="progress progress-striped active">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                  [attr.aria-valuenow]="progressPercent" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="progressPercent+'%'">
                  {{progressPercent}}%
                </div>
              </div>
            </section>
          }
        </div>
        <div class="col-sm-3">
          <div class="upload-assets-file float-end" style="padding-bottom: 5px;">
            <button type="button" (click)="openFileDialog()" id="upload-audio-{{contentBlock.audioBlock.id}}"
            class="btn btn__btn-default btn__orange">Upload MP3</button>
            <div class="file-upload hide">
              <input id="uploadMp3" #fileInput (click)="fileInput.value = null" (change)="fileSelected($event)"
                accept="audio/mp3" class="file-upload__input" type="file" name="preview-file-upload">
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-3 control-label required-field pt-0">
            <label class="control-label fw-bold" for="playbookDescription">Caption</label>
          </div>
          <div class="col-sm-9">
            <app-rich-text-editor [(ngModel)]="audBlock.caption" #caption name="caption">
            </app-rich-text-editor>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal"
        (click)='closeEditAudioModal()'>Cancel</button>
        <button type="button" class="btn btn__btn-default btn__orange" (click)="updateAudioBlock()">Save</button>
      </div>
    </div>
  </ng-template>